import api from "../api";
import { toast } from 'vue3-toastify'

export default {
  namespaced: true,
  state: {
    stores: {},
    store: {},
    rankings: {},
    review: {},
    wallet: {},
    slug: {},
    storeClients: {},
    paginate: {},
  },
  getters: {
    
  },
  actions: {
    async get_stores({ commit }) {
      try {
        api.get("/v1/stores")
          .then((res) => {
            commit("GET_STORES", res.data);
          })
          .catch((error) => {
            commit("ERROR_STORE", error);
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_STORE", e);
      }
    },

    async get_store({ commit }, id) {
      try {
        api.get("/v1/stores/"+id)
          .then((res) => {
            commit("GET_STORE", res.data);
          })
          .catch((error) => {
            commit("ERROR_STORE", error);
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_STORE", e);
      }
    },

    async add_store({ dispatch, commit }, payload = []) {
      try {
        const res = await api.post("/v1/store/add_store", payload);

        console.log("Ad store: ", res);
        // Verifica a resposta
        if (res?.data?.error) {
          toast.warning(res?.data?.message, {
            type: 'default',
            theme: 'colored',
            hideProgressBar: true,
            dangerouslyHTMLString: true
          });
          return { error: res.data.error };
        } else {
          toast.success("Loja criada com sucesso!", {
            type: 'default',
            theme: 'colored',
            hideProgressBar: true,
            dangerouslyHTMLString: true
          });
          return { data: res?.data?.result };
        }
        
      } catch (error) {
        // Lida com erros
        console.log(error); 
        toast.warning("Algo deu errado! Tente novamente mais tarde", {
          type: 'default',
          theme: 'colored',
          hideProgressBar: true,
          dangerouslyHTMLString: true
        });
        
        // Retorna o erro para capturar no "then"
        return { error: error.message || error };
      } finally {
        console.log('Requisição finalizada');
      }
    },

    async update({ dispatch, commit }, payload) {
      try {
        api.post("/v1/update-store/", payload)
          .then((res) => {
            commit("GET_UPT_STORE", res?.data);
            //dispatch("alert/set_alert", {alert_message: res?.data?.message || "Criado/Alterado com sucesso", type_message: 'alert-success'}, { root: true });
            //location.reload();

            toast.success(res?.data?.message || "Criado/Alterado com sucesso", {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });
          })
          .catch((error) => {
            commit("ERROR_UPT_STORE", error);

            toast.warning(error.response.data.message, {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_UPT_STORE", e);
      }
    },

    async delete_product({ dispatch, commit }, id) {
      try {
        api.post("/v1/product-store-delete/", {id: id})
          .then((res) => {
            console.log(res)
            commit("GET_STORE", res?.data?.store);

            //dispatch("alert/set_alert", {alert_message: res?.data?.message || "Removido com sucesso", type_message: 'alert-success'}, { root: true });

            
            //if (window.innerWidth < 480) {
              toast.success("Removido com sucesso.", {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });
            //}
            // commit("GET_STORE", res.data);
          })
          .catch((error) => {
            commit("ERROR_STORE", error);

            toast.warning(error.response.data.message, {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });

            //dispatch("alert/set_alert", {alert_message: "Existem pedidos com esse item, nao pode ser removido", type_message: 'alert-warning'}, { root: true });

          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_STORE", e);
      }
    },

    async save_product({ dispatch, commit }, payload = []) {
      try {
        const res = await api.post("/v1/product-store-save/", payload)
         
          // Verifica a resposta
          if (res?.data?.error) {
            toast.warning("Algo deu errado! Tente novamente mais tarde", {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
            return { error: res.data.error };
          } else {
            toast.success("Criado/Alterado com sucesso.", {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
            return { data: res?.data?.result };
          }

            /*console.log(res)
            commit("GET_STORE", res?.data?.store);
            //dispatch("alert/set_alert", {alert_message: res?.data?.message || "Criado com sucesso", type_message: 'alert-success'}, { root: true });

            //if (window.innerWidth < 480) {
              toast.success("Criado/Alterado com sucesso.", {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });
            //}
            // commit("GET_STORE", res.data);*/
          
          } catch (error) {
            // Lida com erros
            console.log(error);    
            toast.warning("Algo deu errado! Tente novamente mais tarde", {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });
            
            // Retorna o erro para capturar no "then"
            return { error: error.message || error };
          } finally {
            console.log('Requisição finalizada');
          }
    },

    async get_rankings({ commit }, limit = 12) {
      try {
        api.get("/v1/stores-ranking/"+limit)
          .then((res) => {
            commit("GET_RANKING", res.data);
          })
          .catch((error) => {
            commit("ERROR_STORE", error);
          })
          .finally(() => (
            console.log('-')
          ));
      } catch (e) {
        commit("ERROR_STORE", e);
      }
    },

    async get_wallet({ commit }, store_id) {
      try {
        api.get("/v1/store-wallet/"+store_id)
          .then((res) => {
            commit("GET_WALLET", res.data);
          })
          .catch((error) => {
            commit("ERROR_STORE", error);
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_STORE", e);
      }
    },

    async get_review({ commit }, id) {
      try {
        api.get("/v1/reviewStore/"+id)
          .then((res) => {
            commit("GET_REVIEW", res.data);
          })
          .catch((error) => {
            commit("ERROR_STORE", error);
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_STORE", e);
      }
    },

    async get_store_clients({ commit }, payload = []) {
      try {
        api.post("/v1/store-clients", payload)
          .then((res) => {
            commit("GET_STORE_CLIENTS", res.data);
          })
          .catch((error) => {
            commit("ERROR_STORE", error);
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_STORE", e);
      }
    },

    async save_product_full({ commit }, payload) {
      try {
        await api.post("/v1/product-store-full/", payload)
          .then((res) => {
            commit("GET_PRODUCT_FULL", res?.data?.store);
            //location.reload();
            
            setTimeout(() => {
              toast.success("Enviado com sucesso.", {
                type: 'default',
                theme: 'colored',
                hideProgressBar: true,
                dangerouslyHTMLString: true
              });
            }, 100);

          })
          .catch((error) => {
            commit("ERROR_PRODUCT_FULL", error);
            
            toast.warning(error.response.data.message, {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });

            /**toast.warning("Algo deu errado, entre em contato com os desenvolvedores", {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });*/
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_PRODUCT_FULL", e);
      }
    }
  
  },
  mutations: {
    GET_STORES(state, data) {
      state.stores = data
    },
    GET_STORE(state, data) {
      state.store = data
    },
    ERROR_ORDER(state, data) {
      console.log(data)
    },
    ERROR_STORE(state, data) {
      console.log(data)
    },

    GET_ADD_STORES(state, data) {
      state.stores = data; 
    },
    ERROR_ADD_STORE(state, data) {
      console.log(data);
    },

    GET_RANKING(state, data) {
      state.rankings = data; 
    },
    GET_REVIEW(state, data) {
      state.review = data
    },
  
    GET_UPT_STORE(state, data) {
      //location.reload();
      state.store = data; 
    },
    ERROR_UPT_STORE(state, data) {
      console.log(data);
    },

    GET_WALLET(state, data){
      state.wallet = data
    },

    GET_SLUG(state, data) {
      state.slug = data; 
    },

    ERROR_SLUG(state, data) {
      console.log(data);
    },

    GET_PRODUCT_FULL(state, data) {
      state.store = data
    },
    ERROR_PRODUCT_FULL(state, data) {
      console.log(data)
    },

    GET_STORE_CLIENTS(state, data) {
      if (data?.paginate.current_page == 1) {
        state.storeClients = data?.clients
      } else {
        state.storeClients.push(...data?.clients)
      }
      state.paginate = data?.paginate
    },
    /*GET_UPT_ADDRESS(state, data) {
      //location.reload();
      state.store = data; 
    },
    ERROR_UPT_ADDRESS(state, data) {
      console.log(data);
    },*/

  }
}